import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const FONT_FAMILY = "'Manrope', sans-serif";
export const FONT_FAMILY_MONO = "Roboto Mono, ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace"; // When you modify Manrope variants,
// update the font's ID in /config/googleFonts.ts
// to avoid loading the same font twice in the dev environment

const FONT_VARIANTS = [{
  italic: false,
  weight: 300
}, {
  italic: false,
  weight: 400
}, {
  italic: false,
  weight: 500
}, {
  italic: false,
  weight: 600
}, {
  italic: false,
  weight: 700
}, {
  italic: false,
  weight: 800
}];
export const FONTS = [{
  fontName: 'Manrope',
  variants: FONT_VARIANTS
}, {
  fontName: 'Roboto Mono',
  // Used for charts
  variants: FONT_VARIANTS
}];
export const TYPOGRAPHY = derivedThemeValues(_ref => {
  let {
    theme,
    remCalc
  } = _ref;
  return {
    fontFamily: FONT_FAMILY,
    fontFamilyMono: FONT_FAMILY_MONO,
    fontRegular: 500,
    fontSemibold: 600,
    fontWeight: theme.base.fontRegular,
    fontSize: remCalc(16),
    lineHeight: remCalc(24),
    body: {
      fontFamily: FONT_FAMILY,
      fontWeight: theme.base.fontRegular,
      fontSize: remCalc(theme.base.rem),
      lineHeight: remCalc(24),
      color: theme.color.bodyFont
    },
    big: {
      fontSize: remCalc(18),
      lineHeight: remCalc(28)
    },
    small: {
      fontSize: remCalc(14),
      lineHeight: remCalc(20),
      color: theme.color.mutedFont
    },
    heading: {
      fontFamily: FONT_FAMILY,
      fontWeight: theme.base.fontSemibold,
      fontSize: remCalc(20),
      lineHeight: remCalc(28),
      color: theme.color.headingFont
    },
    subheading: {
      fontWeight: theme.base.fontRegular,
      fontSize: remCalc(16),
      lineHeight: remCalc(24),
      color: theme.color.subheadingFont
    },
    h1: {
      fontSize: remCalc(56),
      lineHeight: remCalc(64)
    },
    h2: {
      fontSize: remCalc(48),
      lineHeight: remCalc(60)
    },
    h3: {
      fontSize: remCalc(40),
      lineHeight: remCalc(50)
    },
    h4: {
      fontSize: remCalc(32),
      lineHeight: remCalc(40)
    },
    h5: {
      fontSize: remCalc(24),
      lineHeight: remCalc(32)
    },
    h6: {
      fontSize: remCalc(20),
      lineHeight: remCalc(28)
    }
  };
});